import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import { Box, Button, Typography } from '@mui/material';
import { NoResultAlert } from 'src/components/noResultAlert';
import { Progress } from 'src/components/progress/Progress';
import { IDyTemplate } from 'src/hooks/api/product/dyTemplates';
import { lang } from 'src/utils';

import { StyledDiscardButton } from '../addProductPage/AddProductPage.styled';
import { DyTemplateCard } from './modules/dyTemplateCard';
import {
  ButtonContainer,
  Container,
  OptionWrapper,
  StepContent,
  Wrapper,
} from './TemplateListCards.styled';

interface TemplateSelectionStepProps {
  isLoading: boolean;
  templates: IDyTemplate[];
  selectedTemplate: IDyTemplate | null;
  handleTemplateClick: (template: IDyTemplate) => void;
  handleDiscard: () => void;
  handleNext: () => void;
}

export const TemplateListCards = ({
  isLoading,
  templates,
  selectedTemplate,
  handleTemplateClick,
  handleDiscard,
  handleNext,
}: TemplateSelectionStepProps) => {
  return (
    <Wrapper>
      <Container sx={{ maxWidth: 'lg' }}>
        <Typography variant="h1" gutterBottom>
          {lang.chooseYourPreferredDyTemplate}
        </Typography>

        <StepContent>
          {isLoading ? (
            <Progress />
          ) : (
            <>
              <NoResultAlert isLoading={isLoading} dataToCheck={templates} />
              <OptionWrapper>
                {templates.map((template) => (
                  <DyTemplateCard
                    key={template.id}
                    template={template}
                    isSelected={selectedTemplate?.id === template.id}
                    onClicked={() => handleTemplateClick(template)}
                  />
                ))}
              </OptionWrapper>
            </>
          )}
        </StepContent>
      </Container>

      {!isLoading && (
        <ButtonContainer>
          <Box style={{ flexGrow: 1 }} />
          <StyledDiscardButton variant="text" onClick={handleDiscard}>
            {lang.discard}
          </StyledDiscardButton>
          <Button
            variant="contained"
            disabled={selectedTemplate === null}
            onClick={handleNext}
            endIcon={<KeyboardArrowRight />}>
            {lang.next}
          </Button>
        </ButtonContainer>
      )}
    </Wrapper>
  );
};
